import {Show, Text, VStack} from 'platform/foundation';
import {useFormatCurrency} from 'platform/locale';

import {omit} from 'ramda';

import {MoneyText, type MoneyTextProps} from '@dms/features/new-vehicle';

import {isNotNilOrEmpty, type Nullish} from 'shared/web';

import {t} from './catalogueUi';
import {grossOfNet} from './moneyInput';

export function PriceWithGross(props: MoneyTextProps & {vatRate: string | Nullish}) {
  const formatCurrency = useFormatCurrency();
  const align = props.align ?? 'right';
  const gross = isNotNilOrEmpty(props.vatRate) ? grossOfNet(props.amount, props.vatRate) : null;
  return (
    <VStack spacing={0} align={align === 'right' ? 'flex-end' : 'flex-start'}>
      <MoneyText {...omit(['vatRate'], props)} align={align} />
      <Show when={isNotNilOrEmpty(gross) ? gross : null}>
        {(gross) => (
          <Text size="xSmall" color="secondary" align={align}>
            {`${formatCurrency(Number(gross), props.currency, 2)} ${t('entity.newVehicle.labels.inclVat', 'incl. VAT')}`}
          </Text>
        )}
      </Show>
    </VStack>
  );
}
